import { __require as r } from "../node_modules/@radix-ui/react-use-layout-effect/dist/index2.js";
var i = /* @__PURE__ */ r();
export {
  i as d
};
